<template>
  <div class="order-pay-con">
    <div class="price-con" v-if="sgConfirmOrderPay.totalAmount">￥ {{ sgConfirmOrderPay.totalAmount.toFixed(2) }}</div>
    <div class="btn-con-bottom">
      <div class="btn" @click="toPay">确认支付 ￥ <span v-if="sgConfirmOrderPay.totalAmount">{{ sgConfirmOrderPay.totalAmount.toFixed(2) }}</span></div>
    </div>

    <van-popup
        class="close-tip-con"
        v-model="showCloseTip"
        :close-on-click-overlay="false"
    >
      <div class="title">确认要退出支付？</div>
      <div class="text">您的订单在{{ timeText }}内未支付将被取消，请尽快完成支付。</div>
      <div class="btn-con">
        <div class="btn" @click="closeTipBtn(1)">继续支付</div>
        <div class="btn" @click="closeTipBtn(2)">确认退出</div>
      </div>
    </van-popup>

    <ant-pay
        ref="antpay"
        :show="show"
        :showPayType="true"
        :paynum="paynum"
        :payData="payData"
        :customClose="true"
        @close="onPayClose"
        @onPay="onPay"
    />
  </div>
</template>

<script>
import { getPaySignInfo } from '@/api/pay/payApi'
import { sgOrderInfo, deliveryList } from '@/api/mall/mallOrder'
import AntPay from '@/components/antpay/antpay'
export default {
  components:{
    AntPay
  },
  data(){
    return{
      showCloseTip: false,
      sgConfirmOrderPay: {},
      payData:{},
      show: false, // 支付框
      paynum: '￥0.00', // 需支付的金额
      latestPayTime: '',//最后支付时间
      timer: null,
      timeText: '',
    }
  },
  watch: {

  },
  created(){
    let sgConfirmOrderPay = this.session('sgConfirmOrderPay') || {}
    if(sgConfirmOrderPay.totalAmount){
      this.sgConfirmOrderPay = this.session('sgConfirmOrderPay')
      this.paynum = '￥'+ this.sgConfirmOrderPay.totalAmount.toFixed(2)
      this.getSgOrderInfo(this.sgConfirmOrderPay.orderId)
      window.setTimeout(()=>{
        this.toPay()
      },200)
    }else {
      console.log('无支付参数！！！！！')
      this.$router.go(-1)
    }

  },
  methods: {
    toPay(){
      this.payData.amount = this.sgConfirmOrderPay.totalAmount
      this.show = true
    },
    // 支付弹框相关
    onPayClose(data){
      if(data && data.isShow){
        this.showCloseTip = true
        // this.$dialog.confirm({
        //   title: '确认要退出支付？',
        //   message: '弹窗内容'
        // }).then(() => {
        //   this.show = false
        //   this.$refs.antpay.$customClose()
        // })
      }else {
        this.show = false
      }
    },
    closeTipBtn(type){
      this.showCloseTip = false
      if(type===1){//继续支付

      }else if(type===2){//取消支付
        this.show = false
        this.$refs.antpay.$customClose()
        this.$store.commit('my/change_sgOrderType', 1)
        // this.$router.push({name: 'sgOrder'})
      }
    },

    onPay(obj) {
      console.log('关闭弹框后的obj:', obj);
      this.show = false;
      this.payData.orderNo = this.sgConfirmOrderPay.orderNo
      this.payData.amount = this.sgConfirmOrderPay.totalAmount
      this.payData.orderType = 1;
      this.payData.payType = obj.payType;
      this.payData.userOpenid = this.session('userOpenId');
      if(obj.payType==='blcPay'){
        this.payData.payPassword = obj.payPassword
        this.payData.walletType = 0; //钱包类型，0：个人钱包，1：店铺钱包
        getPaySignInfo(this.payData).then(res=>{
          if(res.code===200){
            this.$refs.antpay.$success('支付成功！')
            this.$store.commit('my/change_sgOrderType', 2)
            let obj = Object.assign({}, this.sgConfirmOrderPay)
            obj.totalAmount = 0
            this.session('sgConfirmOrderPay', obj)
            this.$router.push({name: 'sgOrderPayOK'})
          }else {
            this.$refs.antpay.$close(res.message)
          }
        })
      }else if(obj.payType==='wxJSAPI'){
        let wxPay = Object.assign({}, this.payData);
        wxPay.wxPayType = '省购商城购物'
        this.session('wxPay', wxPay)
        this.$router.push({name: 'wxPay'})
      }
    },


    getSgOrderInfo(orderMergeId){
      sgOrderInfo({orderMergeId}).then(res=>{
        if(res.code===200){
          this.info = res.data
          if(res.data.orderStatus==='WAIT'){//待支付
            this.latestPayTime = new Date(res.data.latestPayTime)
            if(Date.now() < this.latestPayTime){//若未到最后支付时间
              this.countDown()
              this.timer = window.setInterval(()=>{
                this.countDown()
              },1000)
            }
          }
        }else {
          this.$toast(res.message)
        }
      })
    },

    //倒计时
    countDown(){
      let nowDown = parseInt((this.latestPayTime - Date.now())/1000)
      if(nowDown>0){
        let time = parseInt(nowDown/3600)
        let minute = parseInt((nowDown%3600)/60)
        let second = parseInt((nowDown%3600%60))
        this.timeText = (time+'小时'+minute+'分钟')
        if(time===0&minute===0){
          this.timeText = second+'秒'
        }
        // console.log(this.timeText)
      }else {
        window.clearInterval(this.timer)
        this.timer = null
        window.setTimeout(()=>{
          this.$toast('订单已超时！')
          this.$router.go(-1)
        },1000)
      }
    },
  },
  beforeDestroy(){
    if(this.timer){
      window.clearInterval(this.timer)
    }
  }
}
</script>

<style lang="less" scoped>
.order-pay-con{
  position: relative;width: 100%;height: 100%;background-color: #f5f5f5;
  .price-con{
    line-height: 67px;width: 100%;background-color: #fff;
    text-align: center;font-size: 23px;font-weight: bold;
    color: rgb(248,37,37);
  }
  .btn-con-bottom{
    position: absolute;bottom: 140px;left: 0;right: 0;display: flex;justify-content: center;
    .btn{
      width: 351px;height: 50px;display: flex;justify-content: center;align-items: center;
      font-size: 16px;color: #fff;background-color: #1585f3;border-radius: 25px;
    }
  }
  .close-tip-con{
    width: 279px;height: 161px;border-radius: 10px;
    .title{font-size: 16px;flex-wrap: 600;line-height: 1;padding: 25px 0 15px 0;text-align: center;}
    .text{
      font-size: 13px;padding: 0 20px;
    }
    .btn-con{
      display: flex;justify-content: center;padding-top: 19px;
      .btn{
        width: 113px;height: 35px;display: inline-flex;justify-content: center;align-items: center;
        font-size: 14px;color: #fff;background-color: #1585f3;border-radius: 25px;
        &:first-child{
          background-color: #fff;color: #1585f3;border: 1px solid #1585f3;margin-right: 14px;
        }
      }
    }
  }
}
</style>